import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({
  size = 'medium',
  color = 'primary',
  text = '',
  centered = false,
  overlay = false,
  variant = 'spinner',
  className = '',
  ...props
}) => {
  const spinnerClass = [
    'loading-spinner',
    `spinner-${size}`,
    `spinner-${color}`,
    `spinner-${variant}`,
    centered ? 'spinner-centered' : '',
    overlay ? 'spinner-overlay' : '',
    className
  ].filter(Boolean).join(' ');

  const renderSpinner = () => {
    switch (variant) {
      case 'dots':
        return (
          <div className="spinner-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        );
      case 'pulse':
        return <div className="spinner-pulse"></div>;
      case 'bars':
        return (
          <div className="spinner-bars">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        );
      case 'ring':
        return <div className="spinner-ring"></div>;
      default:
        return <div className="spinner-circle"></div>;
    }
  };

  if (overlay) {
    return (
      <div className={spinnerClass} {...props}>
        <div className="spinner-overlay-content">
          {renderSpinner()}
          {text && <div className="spinner-text">{text}</div>}
        </div>
      </div>
    );
  }

  return (
    <div className={spinnerClass} {...props}>
      {renderSpinner()}
      {text && <div className="spinner-text">{text}</div>}
    </div>
  );
};

// Specialized loading components
export const PageLoader = ({ text = 'Cargando página...' }) => (
  <LoadingSpinner
    size="large"
    color="primary"
    text={text}
    centered
    variant="ring"
    className="page-loader"
  />
);

export const ButtonLoader = ({ size = 'small' }) => (
  <LoadingSpinner
    size={size}
    color="white"
    variant="spinner"
    className="button-loader"
  />
);

export const TableLoader = ({ text = 'Cargando datos...' }) => (
  <LoadingSpinner
    size="medium"
    color="primary"
    text={text}
    centered
    variant="dots"
    className="table-loader"
  />
);

export const CardLoader = () => (
  <LoadingSpinner
    size="small"
    color="secondary"
    variant="pulse"
    className="card-loader"
  />
);

export const OverlayLoader = ({ text = 'Procesando...' }) => (
  <LoadingSpinner
    size="large"
    color="primary"
    text={text}
    overlay
    variant="ring"
    className="overlay-loader"
  />
);

export const InlineLoader = ({ text = 'Cargando...' }) => (
  <LoadingSpinner
    size="small"
    color="primary"
    text={text}
    variant="dots"
    className="inline-loader"
  />
);

export default LoadingSpinner;